/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MeteringResolution = 'fifteen_minutes' | 'one_hour' | 'one_day' | 'one_week' | 'one_month' | 'one_year';

export const MeteringResolution = {
    FifteenMinutes: 'fifteen_minutes' as MeteringResolution,
    OneHour: 'one_hour' as MeteringResolution,
    OneDay: 'one_day' as MeteringResolution,
    OneWeek: 'one_week' as MeteringResolution,
    OneMonth: 'one_month' as MeteringResolution,
    OneYear: 'one_year' as MeteringResolution
};

